import type { ChannelType } from '@gr/core/distribution/channels/channel-types';

// Подпись канала в выпадающем списке: в нативном <select> значка нет, поэтому платформа — в тексте.

export interface ChannelOptionSource {
  id: string;
  name: string;
  type: ChannelType;
}

/** «Gen Пожрать · Telegram»; если платформа уже есть в названии («Telegram · блог») — название как есть. */
export function channelOptionLabel(channel: ChannelOptionSource, platform: string): string {
  return channel.name.toLocaleLowerCase('ru').includes(platform.toLocaleLowerCase('ru')) ? channel.name : `${channel.name} · ${platform}`;
}

export function channelOptions(channels: readonly ChannelOptionSource[], platformOf: (type: ChannelType) => string): { value: string; label: string }[] {
  return channels.map((channel) => ({ value: channel.id, label: channelOptionLabel(channel, platformOf(channel.type)) }));
}
